module.exports = __webpack_public_path__ + "img/navodila_slika_1.cb62b817.png";